import { codemirrorOptionsComponentModule } from '../codemirror-options';
import codemirrorIdeOptsTemplate from './codemirror-ide-opts.tpl.html';
import './codemirror-ide-opts.less';
import { simpleRepeaterComponentModule } from '../../simple-repeater/simple-repeater';
import { languages } from '../../../constants/languages';
import { compareIgnoreCase } from '../../../utils/string-utils';

export const codemirrorIdeOptsComponentModule = angular
  .module('Q.components.codemirror.ide-opts', [
    codemirrorOptionsComponentModule,
    simpleRepeaterComponentModule,
  ])

  .directive('codemirrorIdeOpts', function (codemirrorOptions) {
    return {
      restrict: 'E',
      template: codemirrorIdeOptsTemplate,
      link: function (scope, elem, attr) {
        const sharedOpts = codemirrorOptions.sharedOpts;
        scope.languages = languages.known;
        const fileMap = (scope.fileMap = []);
        angular.forEach(sharedOpts.fileMap, (to, from) => {
          fileMap.push({ from, to });
        });
        fileMap.sort((a, b) => {
          return compareIgnoreCase(a.from, b.from);
        });
        scope.hide = scope.$eval(attr.hide || '{}');
        scope.sharedOpts = sharedOpts;
        scope.updateFont = codemirrorOptions.updateFont;

        scope.updateFileMap = () => {
          sharedOpts.fileMap = fileMap
            .filter((a) => a.from && a.to)
            .reduce((map, { from, to }) => {
              map[from] = to;
              return map;
            }, {});
          codemirrorOptions.updateFileMap();
        };
      },
    };
  });
